/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SidebarComponent } from 'src/app/@amiga-pyme/class/sidebar.class';
import { CartSaleService, TypeAddCart } from '../cart/cart-sale.service';

@Component({
  selector: 'pg-product-sale-sidebar',
  templateUrl: './product-sale-sidebar.component.html',
  providers: [MessageService]
})
export class ProductSaleSidebarComponent extends SidebarComponent {
  @Input() type: TypeAddCart;
  itemStock: { label: string; value: string }[];
  maxStock: number;
  netPrice: number;
  settings = {
    title: null,
    tooltip: null
  };
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cartSaleService: CartSaleService
  ) {
    super('Producto SideBar Stock');
  }

  ngOnInit() {
    this.setSettings();
    this.setItemInSideBar();
    const quantityCart = this.item?.selectedChild.quantityInCart
      ? this.item.selectedChild.quantityInCart
      : 0;
    this.netPrice = quantityCart * this.item.selectedChild.precio;
    this.fg = this.fb.group({
      quantityCart: [
        quantityCart,
        [Validators.required, Validators.min(1), Validators.max(this.maxStock)]
      ]
    });
    this.fg.get('quantityCart').valueChanges.subscribe((value) => {
      this.netPrice = Math.round((value * this.item.selectedChild.precio) * 100) / 100;
    });
  }

  onSubmit() {
    if (this.fg.valid) {
      this.item.selectedChild.quantityInCart =
        this.fg.get('quantityCart').value;
      this.addItemIntoCart$({ ...this.item }, this.type);
    }
  }

  setSettings() {
    if (this.type === 'new') {
      this.settings = {
        title: 'Agregar Producto al Carrito',
        tooltip: 'Agregar al carrito'
      };
    } else if (this.type === 'update') {
      this.settings = {
        title: 'Actualizar Producto del Carrito',
        tooltip: 'Actualizar el carrito'
      };
    }
  }

  addItemIntoCart$(data: any, type: TypeAddCart) {
    if (!data) return;
    if (type === 'new') {
      this.addNewItemCart(data);
    } else if (type === 'update') {
      this.updateItemCart(data);
    }
  }

  addNewItemCart(item) {
    const existsItem = this.cartSaleService.itemExistsInCart(item);
    const noStockForItem = item.selectedChild.stock === 0;
    const notInventoriedItem = item.selectedChild.stock === undefined;

    if (existsItem) {
      this.messageService.add({
        severity: 'warn',
        summary: 'El producto ya fue agregado',
        detail: 'Puedes modificar la cantidad en el carrito'
      });
      setTimeout(() => {
        this.close.emit();
      }, 2200);
      return;
    }

    if (noStockForItem) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No hay productos en stock',
        detail: 'No hay suficientes productos para vender'
      });
      setTimeout(() => {
        this.close.emit();
      }, 2200);
      return;
    }

    if (notInventoriedItem) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No hay productos en stock',
        detail: 'El formato de producto aún no ha sido inventariado'
      });
      setTimeout(() => {
        this.close.emit();
      }, 2200);
      return;
    }

    this.cartSaleService.addItem(item);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Agregado',
      detail: `${item.selectedParent.productCode} - ${item.selectedParent.productName} - ${item.selectedChild.format}`
    });
    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  updateItemCart(item) {
    this.cartSaleService.updateItem(item);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Actualizado',
      detail: `${item.selectedParent.productCode} - ${item.selectedParent.productName} - ${item.selectedChild.format}`
    });
    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  setItemInSideBar() {
    const parentFieldsStock = {
      productName: 'Descripción del producto',
      lot: 'Lote',
      expAt: 'Fecha de vencimiento'
    };

    const childFieldsStock = {
      precio: 'Precio de venta',
      // profitMargin: 'Margen de ganancia',
      stock: 'En stock',
      format: 'Presentación'
    };

    this.maxStock = this.item['selectedChild'].stock;

    const parentDataToSidebar = Object.keys(parentFieldsStock).map((key) => {
      return {
        label: parentFieldsStock[key],
        value: this.item.selectedParent[key]
      };
    });
    const childDataToSidebar = Object.keys(childFieldsStock).map((key) => {
      return {
        label: childFieldsStock[key],
        value: this.item.selectedChild[key]
      };
    });

    this.itemStock = [...parentDataToSidebar, ...childDataToSidebar];
  }
}
